<template>
  <div>
    <CategoryInput
      v-for="c in categories"
      :key="c"
      :category="c"
      :services="byCategory[c]"
      :value="value"
      @input="servicesChange"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CategoryInput from './CategoryInput'

export default {  
  components: { CategoryInput },

  props: ['value'],

  computed: {
    ...mapGetters('services',  ['categories', 'byCategory']),
  },

  methods: {
    ...mapActions('services', ['loadAll']),

    servicesChange(newVal) {
      this.$emit('input', newVal)
    },
  },

  created() {
    this.loadAll()
  }
}
</script>